import React, { useState, useEffect } from "react";
import { Modal, Button, Input, Form } from "antd";
import Permission from "../../components/permission/index";
// import firebase from '../../config/firebase';
import perfilService from "../../service/perfil.service";
import "./createListPerfil.css";
import { useSelector } from "react-redux";

export default function CreateListPerfil({ open, onClose, record, onSaveChange }) {

    // const db = firebase.firestore();

    const user = useSelector(state => state.user);

    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    useEffect(() => {
        if (record) {
            form.setFieldsValue({
                nomePerfil: record.nomePerfil,
            });
            setPermissoes(record.permissoes);
            setSelecionarTodosGeral(record.selecionarTodosGeral);
        }
    }, [record, form]);

    const handleOk = () => form.submit();

    const initialPermissoes = {
        freight: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        client: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        driver: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        shipper: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        user: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        mdfe: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        import: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        payment: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        tableIcms: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        ocurrence: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        tablePrice: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        accompaniment: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
        perfil: {
            selecionarTodos: false,
            isView: false,
            isCreate: false,
            isEdit: false,
            isDelete: false,
        },
    };

    const [permissoes, setPermissoes] = useState(initialPermissoes);

    const [selecionarTodosGeral, setSelecionarTodosGeral] = useState(false);

    // handler por grupo
    const handleChange = (grupo, campo) => {
    setPermissoes((prev) => {
        let novoGrupo;

        if (campo === "selecionarTodos") {
        const novoValor = !prev[grupo].selecionarTodos;
        novoGrupo = {
            selecionarTodos: novoValor,
            isView: novoValor,
            isCreate: novoValor,
            isEdit: novoValor,
            isDelete: novoValor,
        };
        } else {
        novoGrupo = {
            ...prev[grupo],
            [campo]: !prev[grupo][campo],
        };

        // recalcula o "selecionarTodos" do grupo
        const todosSelecionados =
            novoGrupo.isView &&
            novoGrupo.isCreate &&
            novoGrupo.isEdit &&
            novoGrupo.isDelete;
        novoGrupo.selecionarTodos = todosSelecionados;
        }

        const novoEstado = {
        ...prev,
        [grupo]: novoGrupo,
        };

        // recalcula o "selecionarTodosGeral"
        const todosOsGruposMarcados = Object.values(novoEstado).every(
        (g) => g.selecionarTodos
        );
        setSelecionarTodosGeral(todosOsGruposMarcados);

        return novoEstado;
    });
    };

    // handler geral
    const handleSelecionarTodosGeral = () => {
    setPermissoes((prev) => {
        const novoValor = !selecionarTodosGeral;
        const novoEstado = {};

        for (const grupo in prev) {
        novoEstado[grupo] = {
            selecionarTodos: novoValor,
            isView: novoValor,
            isCreate: novoValor,
            isEditar: novoValor,
            isDelete: novoValor,
        };
        }

        // atualiza o estado geral
        setSelecionarTodosGeral(novoValor);

        return novoEstado;
    });
    };

    const onFinish = async (values) => {
        setLoading(true);
        try {

            if (record) {
                perfilService.updatePerfil(record.id, {
                    nomePerfil: values.nomePerfil,
                    permissoes: permissoes,
                    selecionarTodosGeral: selecionarTodosGeral,
                    uidShipper: user.uidShipper || "uid não encontrado",
                });
                alert("Perfil atualizado com sucesso!");
                onSaveChange(true);
                onClose();
            }
            else {

                await perfilService.savePerfil({
                    nomePerfil: values.nomePerfil,
                    permissoes: permissoes,
                    selecionarTodosGeral: selecionarTodosGeral,
                    uidShipper: user.uidShipper || "uid não encontrado",
                });
                alert("Perfil criado com sucesso!");
                onSaveChange(true);
                onClose();
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <Modal
                className="Modal"
                open={open}
                title={record ? "Editar Perfil" : "Criar Novo Perfil"}
                onCancel={onClose}
                onOk={handleOk}
                confirmLoading={loading}
                okText="Salvar"
                cancelText="Cancelar"
                destroyOnClose={true}
                afterClose={() => {
                    form.resetFields();
                    setPermissoes(initialPermissoes);
                    setSelecionarTodosGeral(false);
                }}
            >
                <Form className="Form" form={form} layout="vertical" onFinish={onFinish}>
                    <Form.Item
                        className="Form"
                        name="nomePerfil"
                        label="Nome do Perfil"
                        rules={[{ required: true, message: "Informe o nome do perfil" }]}
                    >
                        <Input placeholder="Digite o nome do perfil" />
                    </Form.Item>

                    <Form.Item className="Form" label="Permissões" name="permissions">
                        <Permission
                            permissoes={permissoes}
                            handleChange={handleChange}
                            handleSelecionarTodosGeral={handleSelecionarTodosGeral}
                            selecionarTodosGeral={selecionarTodosGeral}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}